// Authorization
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const NOT_AUTHENTICATED = 'notAuthenticated'
export const RECOVER_PASSWORD = 'recoverPassword'
export const RECOVER_PASSWORD_CODE = 'recoverPasswordCode'

// Orders
export const GET_ALL_ORDERS = 'getAllOrders'
export const GET_APPROVER_ORDERS = 'getApproverOrders'
export const GET_ORDER_DETAILS = 'getOrderDetails'
export const SET_ORDER_STATUS = 'setOrderStatus'
export const SET_SHIPPING_STATUS = 'setShippingStatus'
export const UPLOAD_LABEL_ZIP = 'uploadLabelZip'
export const RESEND_PENDING_EMAIL = 'resendPendingEmail'

//Management
export const GET_ASSOCIATED_APPROVERS = 'getAssociatedApprovers'
export const GET_ALL_USERS = 'getAllUsers'
export const UPDATE_CUSTOMER_APPROVER = 'updateCustomerApprover'
export const ADD_USER = 'addUser'
export const EDIT_USER = 'editUser'
export const DELETE_USER = 'deleteUser'
export const DELETE_CUSTOMER = 'deleteCustomer'

